/* global axios */
import ApiClient from '../ApiClient';

class CaptainCitizenComplaints extends ApiClient {
  constructor() {
    super('captain/citizen_complaints', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, { citizen_complaint: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { citizen_complaint: data });
  }

  archive(id) {
    return axios.patch(`${this.url}/${id}/archive`);
  }

  getStats(params = {}) {
    return axios.get(`${this.url}/stats`, { params });
  }

  addNote(id, content) {
    return axios.post(`${this.url}/${id}/add_note`, { content });
  }

  getCategories() {
    return axios.get(`${this.url}/categories`);
  }
}

export default new CaptainCitizenComplaints();
